function checkIsWebView(): boolean {
  const urlParams = new URLSearchParams(window.location.search);
  const webviewParam = urlParams.get('webview');
  if (webviewParam === 'true' || webviewParam === '1') {
    return true;
  }

  return !!(window as any).ReactNativeWebView;
}

export function useIsWebView(): boolean {
  return checkIsWebView();
}

/**
 * Envia mensagem para fechar a WebView.
 * Tenta ReactNativeWebView.postMessage, iOS WKWebView, Android e window.postMessage como fallback.
 */
export function closeWebView(): void {
  const message = JSON.stringify({ type: 'close' });

  try {
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(message);
      return;
    }

    if ((window as any).webkit?.messageHandlers?.close) {
      (window as any).webkit.messageHandlers.close.postMessage(message);
      return;
    }

    if ((window as any).webkit?.messageHandlers?.callbackHandler) {
      (window as any).webkit.messageHandlers.callbackHandler.postMessage(message);
      return;
    }

    if ((window as any).Android?.finish && typeof (window as any).Android.finish === 'function') {
      (window as any).Android.finish();
      return;
    }

    window.postMessage(message, window.location.origin);
  } catch (error) {
    console.warn('Erro ao tentar fechar webview:', error);
  }
}

export default useIsWebView;
